module.exports = __webpack_public_path__ + "static/media/The_Core_Four_D.44d61568.png";